exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".kyc-modal .modal-body{overflow:visible !important}.kyc-modal .datepicker-container{display:none}.kyc-modal .datepicker-container-show{display:block;top:20%}\n", ""]);

